import React, { Fragment } from 'react'

const Address = ({
    street_address,
    city,
    state,
    setstreet_address,
    setcity,
    setstate,
}) => {
    return (
        <Fragment>
            <div className="customBG-6 p-[2vmax] rounded-2xl">
                <div className="flex item-center justify-between">
                  <div className="w-[14.5%] lg:w-[8.5%] aspect-square bg-[image:var(--gradient-1)] rounded-xl flex-center">
                        <i className="fa-solid fa-map text-white text-[2.3vmax] lg:text-[1.5vmax]"></i>
                    </div>
                    <div className="w-[82%] lg:w-[89%]">
                    
                        <h3 className='  text-[1.8vmax] lg:text-[1.2vmax] font-bold ' >Address</h3>
                        <p className='text-[1.5vmax] lg:text-[0.9vmax] text-gray-600 mt-[0.3vmax] font-[500]'>
                            Where are you Located?
                        </p>
                    </div>
                </div>

                <div className='flex flex-col mt-[2vmax] w-full '>

                    <span className='text-[1.5vmax] lg:text-[1vmax]' >Street Address <span className='text-red-500'>*</span></span>
                    <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">

                        <input
                            type="text"
                            value={street_address}
                            onChange={(e) => setstreet_address(e.target.value)}
                            className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                            placeholder='Enter Street Address'
                        />
                        <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-gray-400 text-[1.8vmax] lg:text-[1.3vmax]">
                            <i className="fa-brands fa-airbnb "></i>
                        </div>
                    </div>
                </div>
                <div className='flex justify-between items-center w-full flex-wrap' >
                    <div className='flex flex-col mt-[1vmax] w-full lg:w-[48%]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]' >city <span className='text-red-500'>*</span></span>
                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">

                            <input
                                type="text"
                                value={city}
                                onChange={(e) => setcity(e.target.value)}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='City'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-gray-400 text-[1.8vmax] lg:text-[1.1vmax]">
                                <i className="fa-regular fa-building"></i>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col mt-[2vmax] w-full lg:w-[48%]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]' >State <span className='text-red-500'>*</span></span>
                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">

                            <input
                                type="text"
                                value={state}
                                onChange={(e) => setstate(e.target.value)}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='State'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-gray-400 text-[1.8vmax] lg:text-[1.1vmax]">
                                <i className="fa-regular fa-map"></i>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </Fragment>
    )
}

export default Address
